import useDashboardStatistics from "../../../hooks/useDashboardStatistics"
import { DateTime } from "luxon"
import { dbDateTimeFormat } from "../../../constants"
import Loader from "../../../components/Loader"
import ApiError from "../../../components/ApiError"

const StatCard = ({ title, value, accent = "bg-primary", icon, iconCls }) => (
  <div className="relative bg-white border border-gray-200 rounded-xl shadow-sm p-4 overflow-hidden">
    <span className={`absolute left-0 top-0 bottom-0 w-1 ${accent}`} />
    <div className="flex items-start justify-between gap-2">
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">
        {title}
      </p>
      {icon && (
        <span className={`p-1.5 rounded-full ${iconCls}`}>
          <span className="material-icons text-lg">{icon}</span>
        </span>
      )}
    </div>
    <p className="text-3xl font-extrabold text-primary mt-2 leading-none tabular-nums">
      {value}
    </p>
  </div>
)

const DashboardStatisticsCards = ({ filters }) => {
  const from =
    filters.from || DateTime.now().startOf("day").toFormat(dbDateTimeFormat)
  const to =
    filters.to || DateTime.now().endOf("day").toFormat(dbDateTimeFormat)
  const patientIssuer = filters.patientIssuer || ""

  const { data, isLoading, error, isError } = useDashboardStatistics({
    from,
    to,
    patientIssuer,
  })

  if (isError) {
    return (
      <div className="mt-4">
        <ApiError axiosError={error} />
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className="py-12 flex justify-center items-center gap-3">
        <Loader className="border-primary" />
        <p>Loading Statistics...</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3.5 mb-6">
      <StatCard
        accent="bg-primary"
        icon="description"
        iconCls="bg-sky-50 text-primary"
        title="Total Orders"
        value={data?.totalOrders || 0}
      />

      <StatCard
        accent="bg-green-500"
        icon="check_circle"
        iconCls="bg-green-50 text-green-600"
        title="Processed Orders"
        value={data?.processedOrders || 0}
      />

      <StatCard
        accent="bg-red-500"
        icon="cancel"
        iconCls="bg-red-50 text-red-600"
        title="Errored Out Orders"
        value={data?.rejectedOrders || 0}
      />

      <StatCard
        accent="bg-green-500"
        icon="bar_chart"
        iconCls="bg-green-50 text-green-600"
        title="Results Generated"
        value={data?.ResultsGenerated || 0}
      />

      <StatCard
        accent="bg-red-500"
        icon="error"
        iconCls="bg-red-50 text-red-600"
        title="Results With Errors"
        value={data?.ResultsErrored || 0}
      />
      <StatCard
        accent="bg-primary"
        icon="done_all"
        iconCls="bg-sky-50 text-primary"
        title="Finalized Results"
        value={data?.ResultsFinalized || 0}
      />
    </div>
  )
}

export default DashboardStatisticsCards
